<template>
  <section class="section">
    <div class="columns is-centered">
      <div class="column">
        <h3 class="title is-4 level">
          <div class="level-left">
            <div class="level-item">
              <span>{{ $t('payments.title') }}</span>
            </div>
          </div>
        </h3>
        <div v-if="hasAccount === false">
          <p>
            {{ $t('payments.texts.noAccount') }}
          </p>
          <br />
          <PublishButton :label=" $t('payments.buttons.creatAccount') " class="is-fullwidth" @click="createAccount" :loading="isCreatingAccount"></PublishButton>
        </div>
        <div v-else-if="hasAccount === true && isOnboardingCompleted === false && isPendingVerification === false">
          <div class="content">
            <p>
              {{ $t('payments.texts.onboardingUncomplete') }}
            </p>
            <p>
              {{ $t('payments.texts.stripeInfoRequired') }}
            </p>
            <ul>
              <li>
                {{ $t('payments.texts.stripeInfoRequiredOne') }}
              </li>
              <li>
                {{ $t('payments.texts.stripeInfoRequiredTwo') }}
              </li>
              <li>
                {{ $t('payments.texts.stripeInfoRequiredThree') }}
              </li>
              <li>
                {{ $t('payments.texts.stripeInfoRequiredFour') }}
              </li>
              <li>
                {{ $t('payments.texts.stripeInfoRequiredFive') }}
              </li>
            </ul>
            <br />
          </div>
          <a v-bind:href="onboardingLink">
            <PublishButton :label=" $t('payments.buttons.goToStripe') " class="is-fullwidth"></PublishButton>
          </a>
        </div>
        <div v-else-if="hasAccount === true && isOnboardingCompleted === false && isPendingVerification === true">
          <div class="content">
            <p>
              {{ $t('payments.texts.pendingVerification') }}
            </p>
          </div>
        </div>
        <div v-else-if="hasAccount === true && isOnboardingCompleted === true">
          <div class="content">
            <p>
              {{ $t('payments.texts.onboardingComplete') }}
            </p>
            <p>
              {{ $t('payments.texts.stripeLogIn') }}
            </p>
          </div>
          <a v-bind:href="stripeAccountLink">
            <PublishButton :label=" $t('payments.buttons.stripeLogIn') " class="is-fullwidth"></PublishButton>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { FooshiApi } from '@/services/fooshiApi.service'
import PublishButton from '@/components/forms/PublishButton'

export default {
  components: {
    PublishButton
  },
  methods: {
    async getAccount () {
      var response = await FooshiApi.getPaymentAccount()
      if (response.status) {
        const data = response.data
        if (data.account === null) {
          this.hasAccount = false
        } else {
          if (data.account.accountId && data.stripe.charges_enabled === false && data.stripe.requirements.pending_verification.length === 0) {
            this.hasAccount = true
            this.isOnboardingCompleted = false
            this.isPendingVerification = false
          }
          if (data.account.accountId && data.stripe.charges_enabled === true && data.stripe.requirements.pending_verification.length === 0) {
            this.hasAccount = true
            this.isOnboardingCompleted = true
            this.isPendingVerification = false
            this.stripeAccountLink = data.login.url
          }
          if (data.account.accountId && data.stripe.charges_enabled === false && data.stripe.requirements.pending_verification.length > 0 && data.stripe.requirements.currently_due.length === 0 && data.stripe.requirements.past_due.length === 0) {
            this.hasAccount = true
            this.isOnboardingCompleted = false
            this.isPendingVerification = true
          }
        }
      }
    },
    async createAccount () {
      this.isCreatingAccount = true
      await FooshiApi.createPaymentAccount()
      await this.getAccount()
      if (this.hasAccount === true && this.isOnboardingCompleted === false) {
        await this.getOnboardingLink()
      }
      this.isCreatingAccount = false
    },
    async getOnboardingLink () {
      var response = await FooshiApi.stripeOboardingLink()
      if (response.status) {
        const data = response.data
        this.onboardingLink = data.url
      }
    }
  },
  async mounted () {
    await this.getAccount()
    if (this.hasAccount === true && this.isOnboardingCompleted === false) {
      await this.getOnboardingLink()
    }
    this.ready = true
  },
  data () {
    return {
      hasAccount: '',
      isOnboardingCompleted: '',
      isPendingVerification: '',
      onboardingLink: '',
      stripeAccountLink: '',
      isCreatingAccount: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Payments.vue